﻿(function (angular) {
  "use strict";

  angular.module("Toyota").directive("tyVideoPlayer", function () {
    var controller = [
      "$scope",
      "$attrs",
      "$element",
      function ($scope, $attrs, $element) {
        var calculateHeight = function () {
          var heightPercentage = $attrs.tyVideoPlayerHeightPercentage;
          $element.find(".video-player__padding").css("padding-top", heightPercentage + "%");

          if ($element.parents(".ty-modal").length) {
            var overlayHeaderHeight = $element.parents(".ty-modal").find(".ty-modal-panel__head").height();
            var videoPlayerMaxWidth = "calc( (100vh - " + overlayHeaderHeight + "px) * 100 / " + heightPercentage + ")";
            $element.find(".video-player__outer").css("max-width", videoPlayerMaxWidth);
          }
        };

        $scope.init = function () {
          $scope.showPlayer = true;

          calculateHeight();
        };

        $scope.init();

        if ($element.parents(".ty-modal-fullscreen").length > 0) {
          $scope.$on("modal-open", function () {
            $scope.showPlayer = true;
          });

          $scope.$on("modal-close", function () {
            $scope.showPlayer = false;
          });
        }
      },
    ];

    return {
      scope: true,
      restrict: "A",
      controller: controller,
      bindToController: true,
    };
  });
})(window.angular);
